module.exports = __webpack_public_path__ + "img/logo.df2c3342.png";